import { CUSTOM_EVENT_PREFIX } from '../../constants/dataFieldKeys/reportColumnKeys';

/**
 * Default metadata based on column type
 */
export const isCustomEvent = (event: string): boolean => {
  return event.indexOf(CUSTOM_EVENT_PREFIX) > -1;
};
